<template>
    <v-checkbox
        v-model="filterHosp"
        label="Filter Hospital/Clinic by Location"
        @change="handleChangeFilterFromHosp($event)"
    />
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['req', 'member_model', 'loading'],
    data: ()=>({
        filterHosp: null
    }),
    watch: {
        filterHosp() {
            this.loading.req.hospital = true
        },
        'req.filter.hosp'(newVal) {
            this.filterHosp = newVal
        }
    },
    methods: {
        ...mapActions(['reqProvinces', 'reqCities', 'reqHospClin']),
        handleChangeFilterFromHosp(value) {
            this.req.filter.hosp = value
            if (this.req.facility && value) {
                this.req.region = String(this.req.facility.hosp_region).trim()
                this.req.province = String(this.req.facility.city_province).trim()
                this.req.city = String(this.req.facility.city_name).trim()
            }
            if (!value) {
                this.req.region = ''
                this.req.province = ''
                this.req.city = ''
            }
            this.reqProvinces({ REGION: this.req.region })
            this.reqCities({ REGION: this.req.region, PROVINCE: this.req.province })
            this.reqHospClin({ REGION: this.req.region, PROVINCE: this.req.province, CITY: this.req.city, TYPE: '', MEMBN: this.member_model.MEMB_N })
        }
    }
}
</script>
